"use client";

import { CreditCard, Error, Login } from "@mui/icons-material";
import { Button, Dialog, Divider, Input, InputAdornment, Paper, Stack, TextField, Typography } from "@mui/material";
import { signIn } from "next-auth/react";
import Link from "next/link";
import { useRouter } from "next/navigation";
import { useState } from "react";
import Loading from "./LoadingScreen";
import SuccessfulScreen from "./SuccessfulScreen";
import ElysiumLogo from "@/public/ElysiumLogo";

export default function LoginForm () {
    
    const router = useRouter();

    const [loading, setLoading] = useState(false)
    const [success, setSuccess] = useState("")
    const [error, setError] = useState("");
    
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    
    
    const handleSubmit = async () => {

        setLoading(true);
        
        try {
            const res = await signIn('credentials', {
                email, 
                password,
                redirect: false,
            });

            if (res.error) {
                setLoading(false);
                setError("Invalid Credentials");
                return;
            } else {
                setLoading(false);
                setSuccess("Login Successful")
                setTimeout(() => {
                    router.push("/dashboard");
                }, 1000);
            }

        } catch (error) {
            console.log(error)
        }

    };

    
    return (
        <main>

            {/* MAIN DISPLAY */}

            <section className="grid place-items-center h-screen">
                <Paper elevation={4} sx={{p: 2}}>
                    <Stack alignItems={"center"} gap={2}>
                        <ElysiumLogo />
                        <Stack gap={1}>
                            <TextField type="text" onChange={(e) => setEmail(e.target.value)} label="email" value={email} />
                            <TextField type="password" onChange={(e) => setPassword(e.target.value)} label="password" value={password} />
                            <Button onClick={()=>{handleSubmit()}} startIcon={<Login />}> Login </Button>
                            <Divider />
                            <Button variant="text" onClick={() => {router.push("/accountcreation/public")}}>Create an Account</Button>
                        </Stack>
                        { (error) && 
                            <Stack direction={"row"} alignItems={"center"} gap={1}>
                                <Error color="error" fontSize="small" />
                                <Typography color={"error"}> {error} </Typography>
                            </Stack>
                        }
                    </Stack>
                </Paper>

                {/* DIALOGS FOR LOADING */}
                <Dialog open={loading}>
                    <Loading />
                </Dialog>

                <Dialog open={success}>
                    <SuccessfulScreen message={success} />
                </Dialog>
                
                {/* ERROR MESSAGE */}


            </section>  
        </main>

    )
    
}